<template>
  <div id="event-content" class="colonnes-resp-full-8 tw-bg-white">

    <div class="colonnes-resp-6 padding-block-1">
      <v-btn
          v-if="getEventPosition"
          class="close-popup"
          color="primary"
          elevation="2"
          fab
          @click="$router.go(-1)"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
      <h1 class="text-3-6 tw-text-blue tw-font-blue tw-font-bold">{{ contenu.title }}</h1>
      <h2 class="text-3-6 tw-text-blue">{{ contenu.acfEvent.organisateurs }}</h2>
      <p class="text-1-8 tw-text-blue tw-italic" v-if="contenu.acfEvent.collaboration">En collaboration avec {{ contenu.acfEvent.collaboration }}</p>

      <div class="tw-my-24">
        <ul>
          <li class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between md:tw-justify-start tw-items-start md:tw-items-center md:tw-gap-24 text-1-2 tw-uppercase tw-font-bold border-top">
            <h4 class="tw-w-64 letter-spacing-1">Date & Heure</h4> <span class="tw-text-right md:tw-text-left tw-text-pink">{{ dateEvent.dateDebut }} <span v-if="dateEvent.dateFin">au {{ dateEvent.dateFin }}</span> | {{ dateEvent.heure }}</span>
          </li>
          <li class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between md:tw-justify-start tw-items-start md:tw-items-center md:tw-gap-24 text-1-2 tw-uppercase tw-font-bold border-top">
            <h4 class="tw-w-64 letter-spacing-1">Lieu</h4> <span class="tw-text-right md:tw-text-left tw-text-pink">{{ dateEvent.lieu }}</span>
          </li>
          <li class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between md:tw-justify-start tw-items-start md:tw-items-center md:tw-gap-24 text-1-2 tw-uppercase tw-font-bold border-top">
            <h4 class="tw-w-64 letter-spacing-1">Ville</h4> <span class="tw-text-right md:tw-text-left tw-text-pink">{{ dateEvent.ville }}</span>
          </li>
          <li class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between md:tw-justify-start tw-items-start md:tw-items-center md:tw-gap-24 text-1-2 tw-uppercase tw-font-bold border-top">
            <h4 class="tw-w-64 letter-spacing-1">Public</h4> <span class="tw-text-right md:tw-text-left tw-text-pink">{{ contenu.acfEvent.public }}</span>
          </li>
        </ul>
        <v-btn v-if="dateEvent.lienPlusDinfos" color="primary" class="tw-mt-12 btn-shape" :href="dateEvent.lienPlusDinfos" target="_blank">
          Plus d'infos sur l'événement
        </v-btn>
      </div>

      <div>
        <v-img class="tw-mb-24" :src="contenu.acfEvent.imagePrincipale.sourceUrl" :aspect-ratio="16/9"/>
        <div v-if="contenu.acfEvent.investigation" class="tw-mt-12">
          <h3 class="text-1-8 tw-text-blue tw-font-bold">Disciplines</h3>
          <div class="text-1-8" v-html="contenu.acfEvent.investigation"/>
        </div>
        <div v-if="contenu.acfEvent.aPropos">
          <h3 class="text-1-8 tw-text-blue tw-font-bold">A propos</h3>
          <div class="text-1-8" v-html="contenu.acfEvent.aPropos"/>
        </div>
        <div v-if="contenu.acfEvent.projet" class="tw-mt-12">
          <h3 class="text-1-8 tw-text-blue tw-font-bold">Inscription du projet dans la démarche générale</h3>
          <div class="text-1-8" v-html="contenu.acfEvent.projet"/>
        </div>

        <div v-if="contenu.acfEvent.urlVideo" class="tw-mt-24">
          <v-responsive :aspect-ratio="16/9">

            <iframe v-if="contenu.acfEvent.urlVideo.includes('vimeo')"
                    :src="contenu.acfEvent.urlVideo.replace('vimeo.com' , 'player.vimeo.com/video')"
                    width="640" height="360" frameborder="0" allowfullscreen></iframe>


            <iframe v-else
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    :src="`${contenu.acfEvent.urlVideo.replace('watch?v=','embed/')}?feature=oembed`"
                    width="600"
                    height="338"
                    frameborder="0"
            />
          </v-responsive>
        </div>

        <div v-if="contenu.acfEvent.galerie" class="tw-mt-12 galerie">
          <v-img class="tw-cursor-pointer" v-for="(image , index) in contenu.acfEvent.galerie" :src="image.sourceUrl" :aspect-ratio="1/1" :key="index" @click="openGallery(index)"/>
        </div>

        <LightBox
            v-if="contenu.acfEvent.galerie"
            ref="lightbox"
            :media="media"
            :show-light-box="false"></LightBox>

        <div class="tw-mt-24" v-if="contenu.acfEvent.contact">
          <h3 class="text-1-8 tw-text-blue tw-font-bold">Contacter l’organisateur</h3>
          <a :href="'mailto:'+contenu.acfEvent.contact" target="_blank" class="text-1-8 lien-hint">{{ contenu.acfEvent.contact }}</a>
        </div>

        <v-btn v-if="contenu.acfEvent.siteOrganisateur" color="primary" class="tw-mt-12 btn-shape" :href="contenu.acfEvent.siteOrganisateur" target="_blank">
          Plus d'infos sur l'organisateur
        </v-btn>

      </div>
    </div>
  </div>
</template>

<script>
import store from "../../../store";
import LightBox from 'vue-it-bigger'
import('vue-it-bigger/dist/vue-it-bigger.min.css') // when using webpack

export default {
  name: "EventContent",
  props : ['contenu'],
  components: {
    LightBox,
  },
  computed : {
    dateEvent() {
      if(store.state.currentEvent) return store.state.currentEvent
      return this.contenu.acfEvent.dates[0]
    },
    getEventPosition() {
      return store.state.fixedEvent
    },
    media() {
      let medias = []
      this.contenu.acfEvent.galerie.forEach((image) => {
        const data = {
          type : "image",
          thumb : image.sourceUrl,
          src : image.sourceUrl,
        }
        medias.push(data)
      })
      return medias
    }
  },
  methods : {
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>